import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(({ library, palette }) => ({
    airport: {
        width: '70px',

        fontSize: 16,
    },
    button: {
        margin: '4px',
        minWidth: '64px',
        maxWidth: '80px',
        fontSize: 14,

        '& .MuiChip-avatar': {
            marginLeft: '8px',
        },

        '&.MuiChip-clickable': {
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
    },
    content: {
        display: 'table-cell',
    },
    divAirport: {
        display: 'table-cell',
        paddingLeft: '8px',
        verticalAlign: 'middle',
    },
    documentButton: {
        margin: '4px',
        minWidth: '88px',
        maxWidth: '96px',
        fontSize: 14,

        '&.MuiChip-clickable': {
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
    },
    sign: {
        backgroundColor: '#00b600',
        color: 'white',

        '&.MuiChip-clickable': {
            '&:focus': {
                backgroundColor: '#00b600',
            },
        },
    },
    warningButton: {
        backgroundColor: library.requiredColor,

        '&.MuiChip-clickable': {
            '&:focus': {
                backgroundColor: library.requiredColor,
            },
        },
    },
    warningIcon: {
        fill: palette.warningColor,
    },
}));
